import { lazy } from 'react';

const ArchiveView = lazy(() => import('./ArchiveView'));

export default ArchiveView;
